// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1_EXf","cls2":"AuthorHeader-cls2_D6A AuthorHeader-cls1_EXf"};